module.exports = __webpack_public_path__ + "img/orange-and-red-lily.358ca867.webp";